import React, { Component } from 'react';
import {
  Modal, Checkbox, Button, InfoTooltip,
} from 'framework-ui-components';
import LogoScadenze from './LogoScadenze';

class ModaleUltimaScadenza extends Component {
  render() {
    const {
      onClose,
      nonVisualizzarePiu,
      onNonVisualizzarePiu,
    } = this.props;

    return (
      <Modal show onClose={onClose} contentClassName="modale-UltimaScadenza">
        <Modal.Header><b>Scadenza 730 2020</b></Modal.Header>
        <Modal.Body>
          <div>
            <span className="stileLogoUltimaScadenza"><LogoScadenze /></span>
          </div>
          <div>
            <label className="ultimaScadenza">
              Hai tempo fino alle <b>16.00 di oggi, 28/09</b> per correggere ed integrare le eventuali dichiarazioni con status "Scartata Audit" nella sezione "Scartate".
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="azioni">
            <label>
              <Checkbox
                checked={nonVisualizzarePiu}
                onChange={onNonVisualizzarePiu}
              />{' '}
              Non visualizzare pi&ugrave; questa schermata
            </label>
            <Button flat primary onClick={onClose}>HO CAPITO</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModaleUltimaScadenza;
